import React from "react";

const ProgramFeesSelectionProcessComponent = () => {
  return (
    <>
      {/* <section className="progfees" id="scrollprogfess">
      <div className="container">
        <div className="row">
          <div className="col-md-10 m-auto">
            <h2 className="title">Programme fees</h2>
            <div className="EarnwhileBg2">
                <div className="row">
                  <div className="col-12">
                    <div className="">
                      <h3>The total course fee is ₹2,55,500 including GST.</h3>
                      <div className="EarnwhiLine"></div>
                     </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        
      </div>
    </section> */}
    <section className="SelectionProcess paddingTopBottom" id="scrollselprocess">
        <div className="container">
            <div className="row">
                <div className="col-md-12 m-auto">
                    <h2 className="title">Selection process</h2>
                    <div className="SelectionProBG">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="step01 stepone d-flex justify-content-center">
                            <div className="stepbg">
                              <p>Step <br/> <span>01</span></p>
                            </div>
                            <div className="stepcontent">
                                <p>Submit  <br/>application</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                            <div className="step01 stepone d-flex">
                                <div className="stepbg">
                                  <p>Step <br/> <span>02</span></p>
                                </div>
                                <div className="stepcontent">
                                    <p>Online <br/>aptitude test</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="step01 stepone d-flex">
                                <div className="stepbg">
                                  <p>Step <br/> <span>03</span></p>
                                </div>
                                <div className="stepcontent">
                                    <p>In-person <br/> interview</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="step01 d-flex">
                                <div className="stepbg">
                                  <p>Step <br/> <span>04</span></p>
                                </div>
                                <div className="stepcontent">
                                    <p>Onboarding</p>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  );
};

export default ProgramFeesSelectionProcessComponent;
